// extracted by mini-css-extract-plugin
export var isPrintedCell = "_yd-1";
export var printerIcon = "_yd-0";